import { render, staticRenderFns } from "./PreviewForms.vue?vue&type=template&id=13bedc1b"
import script from "./PreviewForms.vue?vue&type=script&lang=ts"
export * from "./PreviewForms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports